function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _empty() {}
function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}
function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import * as singleSpa from 'single-spa';
import { PluginManager } from 'ilc-plugins-sdk/browser';
import { PluginsLoader } from './PluginsLoader';
import UrlProcessor from '../common/UrlProcessor';
import { appIdToNameAndSlot, addTrailingSlashToPath } from '../common/utils';
import { setNavigationErrorHandler, addNavigationHook, unsetNavigationErrorHandler, removeNavigationHook } from './navigationEvents/setupEvents';
import { CorsError, RuntimeError, InternalError, NavigationError, FragmentError, CriticalFragmentError, CriticalInternalError } from './errors';
import { triggerAppChange } from './navigationEvents';
import { registryFactory } from './registry/factory';
import Router from './ClientRouter';
import initIlcState from './initIlcState';
import I18n from './i18n';
import TransitionHooksExecutor from './TransitionHooksExecutor';
import ParcelApi from './ParcelApi';
import { BundleLoader } from './BundleLoader';
import { registerApplications } from './registerSpaApps';
import { TransitionManager } from './TransitionManager/TransitionManager';
import IlcEvents from './constants/ilcEvents';
import singleSpaEvents from './constants/singleSpaEvents';
import ErrorHandlerManager from './ErrorHandlerManager/ErrorHandlerManager';
import { FRAGMENT_KIND } from '../common/constants';
import { SdkFactoryBuilder } from './Sdk/SdkFactoryBuilder';
import { TransitionHooks } from './TransitionManager/TransitionHooks/TransitionHooks';
import { PerformanceTransitionHook } from './TransitionManager/TransitionHooks/PerformanceTransitionHook';
import { TitleCheckerTransitionHook } from './TransitionManager/TransitionHooks/TitleCheckerTransitionHook';
import { HrefLangHandler } from './HrefLangHandler';
import { CanonicalTagHandler } from './CanonicalTagHandler';
var _configRoot = /*#__PURE__*/new WeakMap();
var _moduleLoader = /*#__PURE__*/new WeakMap();
var _logger = /*#__PURE__*/new WeakMap();
var _registryService = /*#__PURE__*/new WeakMap();
var _errorHandlerManager = /*#__PURE__*/new WeakMap();
var _transitionManager = /*#__PURE__*/new WeakMap();
var _pluginManager = /*#__PURE__*/new WeakMap();
var _i18n = /*#__PURE__*/new WeakMap();
var _router = /*#__PURE__*/new WeakMap();
var _transitionHooksExecutor = /*#__PURE__*/new WeakMap();
var _urlProcessor = /*#__PURE__*/new WeakMap();
var _bundleLoader = /*#__PURE__*/new WeakMap();
var _sdkFactoryBuilder = /*#__PURE__*/new WeakMap();
var _navigationHooks = /*#__PURE__*/new WeakMap();
var _Client_brand = /*#__PURE__*/new WeakSet();
export var Client = /*#__PURE__*/function () {
  function Client(config) {
    var _this = this;
    _classCallCheck(this, Client);
    _classPrivateMethodInitSpec(this, _Client_brand);
    _classPrivateFieldInitSpec(this, _configRoot, void 0);
    _classPrivateFieldInitSpec(this, _moduleLoader, void 0);
    _classPrivateFieldInitSpec(this, _logger, void 0);
    _classPrivateFieldInitSpec(this, _registryService, void 0);
    _classPrivateFieldInitSpec(this, _errorHandlerManager, void 0);
    _classPrivateFieldInitSpec(this, _transitionManager, void 0);
    _classPrivateFieldInitSpec(this, _pluginManager, void 0);
    _classPrivateFieldInitSpec(this, _i18n, void 0);
    _classPrivateFieldInitSpec(this, _router, void 0);
    _classPrivateFieldInitSpec(this, _transitionHooksExecutor, void 0);
    _classPrivateFieldInitSpec(this, _urlProcessor, void 0);
    _classPrivateFieldInitSpec(this, _bundleLoader, void 0);
    _classPrivateFieldInitSpec(this, _sdkFactoryBuilder, void 0);
    _classPrivateFieldInitSpec(this, _navigationHooks, [function (url) {
      return _classPrivateFieldGet(_transitionHooksExecutor, _this).shouldNavigate(url) ? url : null;
    }, function (url) {
      return _classPrivateFieldGet(_urlProcessor, _this).process(url);
    }]);
    _classPrivateFieldSet(_configRoot, this, config);
    var pluginsLoader = new PluginsLoader();
    _classPrivateFieldSet(_pluginManager, this, _construct(PluginManager, _toConsumableArray(pluginsLoader.load())));
    var reportingPlugin = _classPrivateFieldGet(_pluginManager, this).getReportingPlugin();
    reportingPlugin.setConfig(_classPrivateFieldGet(_configRoot, this));
    _classPrivateFieldSet(_logger, this, reportingPlugin.logger);
    _classPrivateFieldSet(_registryService, this, registryFactory(_classPrivateFieldGet(_logger, this)));
    _classPrivateFieldSet(_errorHandlerManager, this, new ErrorHandlerManager(_classPrivateFieldGet(_logger, this), _classPrivateFieldGet(_registryService, this)));
    var transitionTimeout = 60000;
    _classPrivateFieldSet(_transitionManager, this, new TransitionManager(_classPrivateFieldGet(_logger, this), _classPrivateFieldGet(_configRoot, this).getSettingsByKey('globalSpinner'), _classPrivateFieldGet(_errorHandlerManager, this), transitionTimeout));
    var i18nSettings = _classPrivateFieldGet(_configRoot, this).getSettingsByKey('i18n');
    if (i18nSettings.enabled) {
      _classPrivateFieldSet(_i18n, this, new I18n(i18nSettings, _objectSpread(_objectSpread({}, singleSpa), {}, {
        triggerAppChange: triggerAppChange
      }), _assertClassBrand(_Client_brand, this, _errorHandlerFor).bind(this), _classPrivateFieldGet(_transitionManager, this)));
    }
    var ilcState = initIlcState();
    _classPrivateFieldSet(_router, this, new Router(_classPrivateFieldGet(_configRoot, this), ilcState, _classPrivateFieldGet(_i18n, this), singleSpa, _classPrivateFieldGet(_transitionManager, this).handlePageTransition.bind(_classPrivateFieldGet(_transitionManager, this))));
    _classPrivateFieldSet(_transitionHooksExecutor, this, new TransitionHooksExecutor(_classPrivateFieldGet(_router, this), _classPrivateFieldGet(_pluginManager, this), _assertClassBrand(_Client_brand, this, _onCriticalInternalError).bind(this)));
    _classPrivateFieldSet(_urlProcessor, this, new UrlProcessor(_classPrivateFieldGet(_configRoot, this).getSettingsByKey('trailingSlash')));
    _classPrivateFieldSet(_moduleLoader, this, _assertClassBrand(_Client_brand, this, _getModuleLoader).call(this));
    _classPrivateFieldSet(_sdkFactoryBuilder, this, new SdkFactoryBuilder(_classPrivateFieldGet(_configRoot, this), _classPrivateFieldGet(_i18n, this), _classPrivateFieldGet(_router, this)));
    _classPrivateFieldSet(_bundleLoader, this, new BundleLoader(_classPrivateFieldGet(_configRoot, this), _classPrivateFieldGet(_moduleLoader, this), _classPrivateFieldGet(_sdkFactoryBuilder, this)));
    var hrefLangHandler = new HrefLangHandler(_classPrivateFieldGet(_configRoot, this).getSettingsByKey('i18n'), _classPrivateFieldGet(_logger, this));
    hrefLangHandler.start();
    var canonicalTagHandler = new CanonicalTagHandler(_classPrivateFieldGet(_i18n, this), _classPrivateFieldGet(_logger, this), _classPrivateFieldGet(_router, this));
    canonicalTagHandler.start();
    _assertClassBrand(_Client_brand, this, _preheat).call(this);
    _assertClassBrand(_Client_brand, this, _expose).call(this);
    _assertClassBrand(_Client_brand, this, _configure).call(this);
  }
  return _createClass(Client, [{
    key: "start",
    value: function start() {
      singleSpa.start({
        urlRerouteOnly: true
      });
    }

    /**
     *
     * @param {String} appId application id
     */
  }, {
    key: "unloadApp",
    value: function unloadApp(appId) {
      try {
        var _this2 = this;
        var _appIdToNameAndSlot = appIdToNameAndSlot(appId),
          appName = _appIdToNameAndSlot.appName;
        _classPrivateFieldGet(_bundleLoader, _this2).unloadApp(appName);
        return _await(_awaitIgnored(singleSpa.unloadApplication(appId)));
      } catch (e) {
        return Promise.reject(e);
      }
    }
    /**
     * Unit tests method
     */
  }, {
    key: "destroy",
    value: function destroy() {
      _classPrivateFieldGet(_transitionManager, this).removeEventListeners();
      unsetNavigationErrorHandler();
      _classPrivateFieldGet(_navigationHooks, this).forEach(removeNavigationHook);
    }
  }]);
}();
function _preheat() {
  var _this3 = this;
  // Initializing 500 error page to cache template of this page
  // to avoid a situation when localhost can't return this template in future
  _classPrivateFieldGet(_registryService, this).preheat().then(function () {
    return _classPrivateFieldGet(_logger, _this3).info('ILC: Registry service preheated successfully');
  })["catch"](function (error) {
    var preheatError = new InternalError({
      cause: error,
      message: 'Failed to preheat registry service'
    });
    _classPrivateFieldGet(_errorHandlerManager, _this3).handleError(preheatError);
  });
}
function _getModuleLoader() {
  if (window.System === undefined) {
    var error = new Error("ILC: can't find SystemJS on a page, crashing everything");
    _assertClassBrand(_Client_brand, this, _onCriticalInternalError).call(this, error);
    throw error;
  }
  return window.System;
}
function _errorHandlerFor(appName, slotName) {
  var _this4 = this;
  return function (error, errorInfo) {
    var isCriticalError = false;
    var isAppExists = !!_classPrivateFieldGet(_configRoot, _this4).getConfigForAppByName(appName);
    if (!isAppExists) {
      isCriticalError = true;
    } else {
      try {
        var fragmentKind = _classPrivateFieldGet(_router, _this4).getRelevantAppKind(appName, slotName);
        isCriticalError = [FRAGMENT_KIND.primary, FRAGMENT_KIND.essential].includes(fragmentKind);
      } catch (error) {
        isCriticalError = true;
      }
    }
    var errorParams = {
      cause: error,
      message: error.message,
      data: _objectSpread(_objectSpread({}, errorInfo), {}, {
        name: appName,
        slotName: slotName
      })
    };
    var fragmentError = isCriticalError ? new CriticalFragmentError(errorParams) : new FragmentError(errorParams);
    _classPrivateFieldGet(_errorHandlerManager, _this4).handleError(fragmentError);
  };
}
function _onNavigationError(error, errorInfo) {
  var navigationError = new NavigationError({
    message: error.message,
    data: errorInfo,
    cause: error
  });
  _classPrivateFieldGet(_errorHandlerManager, this).handleError(navigationError);
}
function _onCriticalInternalError(error, errorInfo) {
  var criticalError = new CriticalInternalError({
    message: error.message,
    data: errorInfo,
    cause: error
  });
  _classPrivateFieldGet(_errorHandlerManager, this).handleError(criticalError);
}
function _isCorsError(event) {
  var error = event.error,
    colno = event.colno,
    lineno = event.lineno;
  return !error && lineno === 0 && colno === 0;
}
function _onRuntimeError(event) {
  var error = event.error;
  if (_assertClassBrand(_Client_brand, this, _isCorsError).call(this, event)) {
    error = new CorsError({
      message: event.message
    });
  } else {
    event.preventDefault();
  }
  var fileName = event.filename;
  var moduleInfo = _classPrivateFieldGet(_moduleLoader, this).getModuleInfo(fileName);
  if (moduleInfo === null) {
    moduleInfo = {
      name: 'UNKNOWN_MODULE',
      dependants: []
    };
  }
  var runtimeError = new RuntimeError({
    message: error.message,
    cause: error,
    data: _objectSpread(_objectSpread({}, moduleInfo), {}, {
      location: {
        fileName: fileName,
        colNo: event.colno,
        lineNo: event.lineno
      }
    })
  });
  _classPrivateFieldGet(_errorHandlerManager, this).handleError(runtimeError);
}
function _onLifecycleError(error) {
  var _appIdToNameAndSlot2 = appIdToNameAndSlot(error.appOrParcelName),
    appName = _appIdToNameAndSlot2.appName,
    slotName = _appIdToNameAndSlot2.slotName;
  _classPrivateFieldGet(_transitionManager, this).reportSlotRenderingError(slotName);
  _assertClassBrand(_Client_brand, this, _errorHandlerFor).call(this, appName, slotName)(error);
}
function _configure() {
  _classPrivateFieldGet(_navigationHooks, this).forEach(addNavigationHook);

  // TODO: window.ILC.importLibrary - calls bootstrap function with props (if supported), and returns exposed API
  // TODO: window.ILC.importParcelFromLibrary - same as importParcelFromApp, but for libs
  registerApplications(_classPrivateFieldGet(_configRoot, this), _classPrivateFieldGet(_router, this), _assertClassBrand(_Client_brand, this, _errorHandlerFor).bind(this), _classPrivateFieldGet(_bundleLoader, this), _classPrivateFieldGet(_transitionManager, this), _classPrivateFieldGet(_sdkFactoryBuilder, this), _classPrivateFieldGet(_errorHandlerManager, this));
  setNavigationErrorHandler(_assertClassBrand(_Client_brand, this, _onNavigationError).bind(this));
  window.addEventListener('error', _assertClassBrand(_Client_brand, this, _onRuntimeError).bind(this));
  var transitionHook = new TransitionHooks(_classPrivateFieldGet(_logger, this));
  var performanceHook = new PerformanceTransitionHook(_classPrivateFieldGet(_router, this).getCurrentRoute, _classPrivateFieldGet(_logger, this));
  var titleHook = new TitleCheckerTransitionHook(_classPrivateFieldGet(_router, this).getCurrentRoute, _classPrivateFieldGet(_logger, this));
  transitionHook.addHook(performanceHook);
  transitionHook.addHook(titleHook);
  transitionHook.subscribe();
  singleSpa.addErrorHandler(_assertClassBrand(_Client_brand, this, _onLifecycleError).bind(this));
  singleSpa.setBootstrapMaxTime(5000, false);
  singleSpa.setMountMaxTime(5000, false);
  singleSpa.setUnmountMaxTime(3000, false);
  singleSpa.setUnloadMaxTime(3000, false);
}
function _addIntlChangeHandler(handler) {
  if (typeof handler !== 'function') {
    throw new Error('onIntlChange should pass function handler as first argument');
  }
  window.addEventListener(IlcEvents.INTL_UPDATE, function (event) {
    var intlValues = {
      locale: event.detail.locale,
      currency: event.detail.currency
    };
    handler(intlValues);
  });
}
function _addRouteChangeHandlerWithDispatch(handler) {
  var _this5 = this;
  if (typeof handler !== 'function') {
    throw new Error('onRouteChange should pass function handler as first argument');
  }
  var wrappedHandler = function wrappedHandler(event) {
    var route = _classPrivateFieldGet(_router, _this5).getCurrentRoute();
    var ilcEvent = new CustomEvent('ilc:onRouteChange', {
      detail: {
        basePath: route.basePath,
        reqUrl: route.reqUrl
      }
    });
    handler(event, ilcEvent);
  };
  window.addEventListener(singleSpaEvents.ROUTING_EVENT, wrappedHandler);
  return function () {
    return window.removeEventListener(singleSpaEvents.ROUTING_EVENT, wrappedHandler);
  };
}
function _matchCurrentRoute(url) {
  var currentRoute = _classPrivateFieldGet(_router, this).getCurrentRoute();
  var currentUrl = currentRoute.reqUrl;

  // add trailing slash to urls if it's missing
  currentUrl = addTrailingSlashToPath(currentUrl);
  url = addTrailingSlashToPath(url);
  return currentUrl === url;
}
function _expose() {
  var _this6 = this;
  // Here we expose window.ILC.define also as window.define to ensure that regular AMD/UMD bundles work correctly by default
  // See docs/umd_bundles_compatibility.md
  if (!_classPrivateFieldGet(_configRoot, this).getConfig().settings.amdDefineCompatibilityMode) {
    window.define = window.ILC.define;
  }
  var parcelApi = new ParcelApi(_classPrivateFieldGet(_configRoot, this).getConfig(), _classPrivateFieldGet(_bundleLoader, this), _classPrivateFieldGet(_sdkFactoryBuilder, this).getSdkAdapterInstance.bind(_classPrivateFieldGet(_sdkFactoryBuilder, this)));
  Object.assign(window.ILC, {
    loadApp: _classPrivateFieldGet(_bundleLoader, this).loadApp.bind(_classPrivateFieldGet(_bundleLoader, this)),
    unloadApp: this.unloadApp.bind(this),
    navigate: _classPrivateFieldGet(_router, this).navigateToUrl.bind(_classPrivateFieldGet(_router, this)),
    onIntlChange: _assertClassBrand(_Client_brand, this, _addIntlChangeHandler).bind(this),
    onRouteChange: _assertClassBrand(_Client_brand, this, _addRouteChangeHandlerWithDispatch).bind(this),
    matchCurrentRoute: _assertClassBrand(_Client_brand, this, _matchCurrentRoute).bind(this),
    mountRootParcel: singleSpa.mountRootParcel.bind(singleSpa),
    importParcelFromApp: parcelApi.importParcelFromApp.bind(this),
    getIntlAdapter: function getIntlAdapter() {
      return _classPrivateFieldGet(_i18n, _this6) ? _classPrivateFieldGet(_i18n, _this6).getAdapter() : null;
    },
    getAllSharedLibNames: function getAllSharedLibNames() {
      return Promise.resolve(Object.keys(_classPrivateFieldGet(_configRoot, _this6).getConfig().sharedLibs));
    },
    getSharedLibConfigByName: function getSharedLibConfigByName(name) {
      return Promise.resolve(_classPrivateFieldGet(_configRoot, _this6).getConfigForSharedLibsByName(name));
    },
    getApplicationConfigByName: function getApplicationConfigByName(name) {
      return Promise.resolve(_classPrivateFieldGet(_configRoot, _this6).getConfigForAppByName(name));
    },
    getSharedLibConfigByNameSync: function getSharedLibConfigByNameSync(name) {
      return _classPrivateFieldGet(_configRoot, _this6).getConfigForSharedLibsByName(name);
    },
    // @Deprecated
    // This method was designed to allow to create an app w/o singleSPA invocation (Case for dynamically loaded application)
    // It leads to situation when fragment creates dependency to ilc-sdk
    // Ilc has ilc-sdk dependency as well
    // So we are not protected from deps version mismatch :(
    // To solve it we created SdkFactoryBuilder that allow to create AppSdk instances and passing it to the app
    // So global 'getAppSdkAdapter' has no sence any more. We will remove it in next major release.
    getAppSdkAdapter: _classPrivateFieldGet(_sdkFactoryBuilder, this).getSdkAdapterInstance.bind(_classPrivateFieldGet(_sdkFactoryBuilder, this))
  });
}